import { RenderDataType } from "@/commons/interface/geometry/primitive";
import localStore from "@/commons/store/local-store";
import { bimAxios } from "@/config/axios";
import { AxiosResponse } from "axios";
import qs from "qs";


export function createPrimitive(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/primitives`, data, {
        params: {
            ...params,
        }
    })
}

export function createPrimitiveMulti(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/primitives/multi`, data, {
        params: {
            ...params,
        }
    })
}

export function findPrimitivesInGraphic(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/primitives`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}
export function findPrimitivesInGraphicByTypes(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/primitives/types`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}
export function findPrimitiveUuidsInGraphicByTypes(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/primitives/types/uuid`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}
export function findPrimitivesByName(projectUuid: string, name: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/primitives/name`, {
        params: {
            ...params,
            name: name,
        }
    })
}
export function findPrimitivesByUuid(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/primitives/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function deletePrimitivesInGraphic(uuids: string[], projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/primitives/delete`, uuids, {
        params: {
            ...params,
            projectUuid: projectUuid,
        }
    })
}
export function updateComponentEntities(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/primitives/components/multi`, data, {
        params: {
            ...params,
        }
    })
}
// 移动图元到某模型
export function updatePrimitivesModel(primitiveUuids: string[], projectUuid: string, targetmodelUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.put(`/primitives/move-model`, primitiveUuids, {
        params: {
            ...params,
            projectUuid: projectUuid,
            modelUuid: targetmodelUuid,
        }
    })
}
// ------------------备份------------------
// 备份项目图元
export function backupPrimitivesByProjectUuid(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/backups`, {
        params: {
            ...params,
        }
    })
}

// 获取项目备份列表
export function getCollectionBackupsByProjectUuid(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/backups`, {
        params: {
            ...params,
        }
    })
}

// 载入备份
export function loadBackupByProjectUuidAndTime(projectUuid: string, time: number, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.put(`/projects/${projectUuid}/backups`, null, {
        params: {
            ...params,
            time: time
        }
    })
}

// 删除备份
export function deleteBackupByProjectUuidAndTime(projectUuid: string, time: number, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/backups`, {
        params: {
            ...params,
            time: time
        }
    })
}

// 保存渲染数据备份
export function exportRenderData(typeUuid: string, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/render-datas/${typeUuid}`, data, {
        params: {
            ...params,
        }
    })
}

// 获取渲染数据类型列表
export function getRenderDataTypeList(projectUuid: string, modelUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/models/${modelUuid}/render-data-types`, {
        params: {
            ...params,
        }
    })
}

// 添加渲染数据类型
export function addRenderDataType(projectUuid: string, modelUuid: string, data: RenderDataType, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/render-data-types`, data, {
        params: {
            ...params,
        }
    })
}

// 删除渲染数据类型
export function deleteRenderDataType(typeUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.delete(`/render-data-types/${typeUuid}`, {
        params: {
            ...params,
        }
    })
}

// 更新默认显示类型
export function updateRenderDataType(typeUuid: string, data: RenderDataType, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.put(`/render-data-types/${typeUuid}`, data, {
        params: {
            ...params,
        }
    })
}


//直接下载项目数据
export function newDownloadBackup(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/new-backups`, {
        params: {
            ...params,
        }
    })
}

// 下载小程序数据
export function downloadRenderDataBackup(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/render-data/backups`, {
        params: {
            ...params,
        }
    })
}

// 载入小程序数据
export function addRenderTypeByData(projectUuid: string, modelUuid: string, data: RenderDataType[], params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/render-types-by-data`, data, {
        params: {
            ...params,
        }
    })
}